import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './HeaderSteps.style.less';

export default class HeaderSteps extends PureComponent {
  render = () => {
    const {
      currentStep,
      stepOneTitle,
      stepOneDescription,
      stepTwoTitle,
      stepTwoDescription,
      stepThreeTitle,
      stepThreeDescription,
    } = this.props;

    return (
      <div className="register-step-wrapper">
        <div className="step-number selected">1</div>
        <div className="step-description-wrapper">
          <div className="step-title">{stepOneTitle}</div>
          <div className="step-sub-title">{stepOneDescription}</div>
        </div>
        <div
          className={currentStep === 1 ? 'step-line' : 'step-line selected'}
        ></div>
        <div
          className={currentStep > 1 ? 'step-number selected' : 'step-number'}
        >
          2
        </div>
        <div className="step-description-wrapper">
          <div className="step-title">{stepTwoTitle}</div>
          <div className="step-sub-title">{stepTwoDescription}</div>
        </div>
        <div
          className={currentStep === 3 ? 'step-line selected' : 'step-line'}
        ></div>
        <div
          className={currentStep === 3 ? 'step-number selected' : 'step-number'}
        >
          3
        </div>
        <div className="step-description-wrapper">
          <div className="step-title">{stepThreeTitle}</div>
          <div className="step-sub-title">{stepThreeDescription}</div>
        </div>
      </div>
    );
  };
}

HeaderSteps.propTypes = {
  currentStep: PropTypes.number,
  stepOneTitle: PropTypes.string,
  stepOneDescription: PropTypes.string,
  stepTwoTitle: PropTypes.string,
  stepTwoDescription: PropTypes.string,
  stepThreeTitle: PropTypes.string,
  stepThreeDescription: PropTypes.string,
};

HeaderSteps.defaultProps = {
  currentStep: 1,
  stepOneTitle: '',
  stepOneDescription: '',
  stepTwoTitle: '',
  stepTwoDescription: '',
  stepThreeTitle: '',
  stepThreeDescription: '',
};
